import './Dashboard.css';
import React from 'react';
import QuoteForm from '../QuoteForm/QuoteForm';
import stockPhoto from '../../Assets/headerPhoto.jpg';
import windowCard from '../../Assets/windowCard.jpeg';
import doorCard from '../../Assets/doorCard.jpeg';
import roofingCard from '../../Assets/roofingCard.jpeg';
import ServicesCard from '../ServicesCard/ServicesCard';
import CompanySlider from '../CompanySlider/CompanySlider';
import { Link } from 'react-router-dom';

function Dashboard() {
  return (
    <div>
    <div class="info">
      <a class="MainPhoto">
      </a>
      <div class="aboutUs">
        Local Family Owned <br></br>  and Operated Business

      </div>
      <QuoteForm />
    </div>
        <div class="services">
          <h2> Local Colorado Services</h2>
          We are proud to be a local family-owned and operated business,
          offering sales and installation of our products at a fair price.
          For our family, it’s very rewarding to help customers improve their homes,
          and we enjoy working with the members of the community we’ve lived in all of our lives.
          <section class="serviceGrid">
            <ServicesCard
              image={windowCard}
              title="Windows"
              description="If you need windows due to hail damage or just because what you have is becoming old, tired, and outdated. We can replace any style (sliding, single, double hung). With the manufacturer of your choice. If you desire a different color to give your house a whole new look."
              link = "windows"
            />
            <ServicesCard
              image={roofingCard}
              title="Roofing"
              description="At DNS, we are happy to give you a free estimate on your roof to see if you have storm damage or if your roof is worn and in need of replacement."
              link = "roofing"
            />
            <ServicesCard
              image={doorCard}
              title="Doors"
              description="Entry doors are available in many different styles and designs with a vast array of glass and material options. We offer single entry, french, patio or entry doors with transoms and sidelites. DNS would love to assist you in choosing and designing the dream entry or sliding patio door system for your home."
              link = "doors"
            />
            <ServicesCard
              image={stockPhoto}
              title="Painting"
              description="Painting and staining are often the most overlooked part of home maintenance. Painting is your original defense against harsh weather in Colorado. DNS offers experienced painters that know preparation is as important as the final product. Reach out today for a free estimate."
              link = "painting"
            />
            <ServicesCard
              image={stockPhoto}
              title="Gutters"
              description="If your gutters are blocked, broken, or not functioning properly, rainwater can accumulate on the ground and seep into a home’s foundation. We offer 6” gutters which help when we are at peak run off, as well as it's easier to keep your gutter clean."
              link = "gutters"
            />
            <ServicesCard
              image={stockPhoto}
              title="Stucco"
              description="Our professional stucco contractor services are tailored to meet your specific needs."
              link = "stucco"
            />
          </section>
          <section className="companySlider">
            <h3>ASSOCIATIONS AND PRODUCTS</h3>
            <CompanySlider/>
          </section>
        </div>
      </div>
  )
}

export default Dashboard;
